/*
  squid 계측 — globalbecon 테마
  beconnow 라이브러리(becon-fe-lib src/my-analytics)의 추적기를 바닐라로 옮겼다. 판정 상수와 이름 규칙은 그쪽과 같게 둔다 —
  세 사이트의 ui_click · dead_click · rage_click · section_view · scroll_depth 가 BigQuery 한 표에서 만나야 한다.

  ★먼저 읽을 곳 — squid 저장소 문서/참고/2026-09-25_GB계측_설계.md · 레지스트리/계측.yaml(이벤트 사전 · 클릭_이름)
  ★차원(site · screen_name · …)은 snippets/squid-analytics.liquid 가 head 에서 먼저 놓는다. 여기서는 이벤트만 민다.
  ★여기서 새 이벤트 이름이나 매개변수를 만들면 GTM 트리거 허용 목록 · GTM 변수 · GA4 맞춤 측정기준도 같이 늘려야 한다.
    안 늘리면 dataLayer 에는 보이는데 GA4 에는 안 온다 (그 반대도 조용하다).
  ★page_view 와 전자상거래(view_item · add_to_cart · purchase …)는 Shopify Google 앱이 보낸다 — 여기서 다시 쏘지 않는다.
*/
(function () {
  'use strict';

  var w = window;
  var doc = document;
  var cfg = w.squidAnalytics;
  if (!cfg || cfg.installed || !doc.addEventListener) return;
  cfg.installed = true;

  var dl = (w.dataLayer = w.dataLayer || []);

  /* ───────── dataLayer — 직전 이벤트 키를 지우고 민다 (beconnow dataLayer.ts pushEvent 와 같은 규칙) ─────────
     GTM 데이터 영역은 키를 합쳐서 기억한다. 안 지우면 ui_click 의 element_id 가 다음 section_view 에 묻어 나간다.
     차원 키(site · screen_name · user_id · first_touch …)는 지우지 않는다. */
  var dimKeys = { user_id: 1, first_touch: 1 };
  Object.keys(cfg.dims || {}).forEach(function (k) { dimKeys[k] = 1; });
  var previousKeys = [];

  function cleanParams(params) {
    var out = {};
    Object.keys(params || {}).forEach(function (k) {
      var v = params[k];
      if (v === undefined || v === null || v === '') return;
      if (typeof v === 'boolean') v = v ? 'true' : 'false';
      out[k] = v;
    });
    return out;
  }

  /* ★동의 — 판정이 나기 전에는 이벤트를 모아 둔다
     2026-09-28 바로잡음: 09-25 에는 「Consentmo 가 동의 기본값을 민다」고 보고 아무 consent default 나 기다렸다.
     실제로 그 기본값은 구글 쇼핑몰 앱이 0.4초에 미는 「전부 허용」이었고(Consentmo 무료 등급엔 구글 동의 모드 연동이 없다),
     손님이 거부하면 앱이 멈춰 아무도 안 밀어서 5초 뒤 동의 신호 없이 나갔다.
     이제 GTM 태그 「Consent | 기본값·Shopify 동의 → 구글」이 Shopify 동의 저장소(Consentmo 가 채운다)를 읽고
     판정을 구글에 알린 뒤 `squid_consent_ready` 를 민다 — 그것을 기다린다. 5초 안에 안 오면(GTM 이 안 떴을 때) 그냥 민다. */
  var CONSENT_WAIT_MS = 5000;
  var consentReady = false;
  var queued = [];
  function hasConsentDefault() {
    for (var i = 0; i < dl.length; i += 1) {
      var e = dl[i];
      if (e && typeof e === 'object' && e.event === 'squid_consent_ready') return true;
    }
    return false;
  }
  function releaseQueue() {
    if (consentReady) return;
    consentReady = true;
    var q = queued;
    queued = [];
    q.forEach(function (x) { pushEvent(x[0], x[1]); });
  }
  (function waitConsent(started) {
    if (hasConsentDefault()) return releaseQueue();
    if (Date.now() - started >= CONSENT_WAIT_MS) return releaseQueue();
    w.setTimeout(function () { waitConsent(started); }, 100);
  })(Date.now());

  function pushEvent(name, params) {
    if (!consentReady) {
      queued.push([name, params]);
      return;
    }
    var clean = cleanParams(params);
    var stale = previousKeys.filter(function (k) { return !(k in clean) && !dimKeys[k]; });
    if (stale.length) {
      var clear = {};
      stale.forEach(function (k) { clear[k] = undefined; });
      dl.push(clear);
    }
    var ev = { event: name };
    Object.keys(clean).forEach(function (k) { ev[k] = clean[k]; });
    dl.push(ev);
    previousKeys = Object.keys(clean);
  }
  cfg.push = pushEvent;

  /* ───────── 유입 — 첫 유입(localStorage)과 이 방문의 유입(sessionStorage + 탭끼리 나누는 30분 사본 localStorage) ─────────
     첫 유입은 한 번만 쓰고 덮지 않는다 (beconnow attribution.ts 와 같은 꼴).
     이 방문의 유입은 2026-11-02 부터 새 탭에도 이어진다 (아래 squid_session_touch_shared) — 그 앞의 Calendly utm 은 «이 탭의 유입»이다.
     ★동의 — 분석 동의가 확인될 때만 localStorage 에 둔다. 모를 때·거부면 sessionStorage 에만 두고,
       동의가 오면(visitorConsentCollected) 그때 옮긴다. */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var CLICK_KEYS = ['gclid', 'fbclid', 'ad_id', 'placement'];
  var OWN_HOST = /(^|\.)globalbecon\.com$|^withbecon\.myshopify\.com$/i;
  /* 쇼피파이 자체 도메인 — Shop 로그인(shop.app)·고객 계정·결제·관리자(*.shopify.com)에서 돌아온 것 〔2026-10-12〕
     가격이 로그인 뒤에만 보이는 상품이라 광고로 온 손님이 Shop 로그인을 거쳐 돌아온다 → 그걸 «다른 사이트에서 새로 옴»으로 치면
     이번 방문 유입이 shop.app 으로 갈아 끼워지고 Calendly 꼬리표가 덮인다 (10-12 실측: shop.app 거친 43명 중 19명이 24시간 안에 광고로 먼저 왔다).
     그래서 유입 칸에는 남기되(처음부터 Shop 앱 장터에서 온 손님은 shop.app 그대로) 이번 방문 유입을 «갈아 끼우는 신호»로는 안 친다.
     ★다른 상점(*.myshopify.com)은 진짜 외부 유입이라 넣지 않는다. 정본 squid 레지스트리/계측.yaml UTM.매체별.사이트_안_Calendly.규칙 */
  var SHOPIFY_HOST = /(^|\.)shop\.app$|(^|\.)shopify\.com$/i;

  function storage(kind) {
    try { var s = w[kind]; var t = '__squid_t'; s.setItem(t, '1'); s.removeItem(t); return s; } catch (e) { return null; }
  }
  var local = storage('localStorage');
  var session = storage('sessionStorage');

  function readJson(store, key) {
    if (!store) return null;
    try { return JSON.parse(store.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function writeJson(store, key, value) {
    if (!store) return;
    try { store.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function analyticsAllowed() {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) {}
    return null; // 모른다 — 동의 API 가 아직 안 떴다
  }

  /* ★배너 없는 지역의 «고르기 전» 찌꺼기를 푼다 (2026-10-09 · 재욱 «클릭 안 하면 다 허용»)
     Consentmo «고르기 전» 상태(분석 no · 광고 yes)가 Shopify 동의 저장소에 남으면, 그 지역에서 배너를 뺀 뒤
     (미국 10-02 · 호주·뉴질랜드·퀘벡 밖 캐나다 10-09) 배너가 다시 안 떠서 영영 안 풀린다 — 그 손님 구매가 GA4 에서 빠진다
     (us2183 · 플로리다 데스크톱 · 10-09 재현). 셋 다일 때만 푼다: 지역이 배너 지역(cfg.consentBannerRegions) 밖 ·
     저장값이 정확히 그 꼴 · Consentmo 에서 직접 고른 기록(cookieconsent_status) 없음. 직접 고른 손님과 배너 지역은 안 건드린다.
     풀면 visitorConsentCollected 가 떠서 GTM 동의 태그가 구글에 «허용»을 다시 알린다. */
  var bannerRegions = cfg.consentBannerRegions || [];
  function inBannerRegion(region) {
    if (!bannerRegions.length) return true; // 목록이 없으면 모른다 — 안 푼다
    for (var i = 0; i < bannerRegions.length; i += 1) if (region.indexOf(bannerRegions[i]) === 0) return true;
    return false;
  }
  function consentChosen() {
    if (/(?:^|;\s*)cookieconsent_status=/.test(doc.cookie)) return true;
    var g = readJson(local, 'gdprCache');
    return !!(g && g.cookieconsent_status);
  }
  function unstickConsent(cp) {
    try {
      var v = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      var region = typeof cp.getRegion === 'function' ? cp.getRegion() || '' : '';
      if (!v || v.analytics !== 'no' || v.marketing !== 'yes' || !region || inBannerRegion(region) || consentChosen()) return;
      cp.setTrackingConsent({ analytics: true, marketing: true, preferences: true }, function () {});
    } catch (e) {}
  }
  (function whenPrivacyApi(started) {
    var cp = w.Shopify && w.Shopify.customerPrivacy;
    if (cp && typeof cp.setTrackingConsent === 'function') return unstickConsent(cp);
    if (Date.now() - started >= 10000) return;
    w.setTimeout(function () { whenPrivacyApi(started); }, 200);
  })(Date.now());

  function readTouch() {
    var q = {};
    try {
      var sp = new URLSearchParams(w.location.search);
      UTM_KEYS.concat(CLICK_KEYS).forEach(function (k) {
        var v = sp.get(k);
        if (v) q[k] = v.slice(0, 100);
      });
    } catch (e) {}
    var refHost = '';
    try { refHost = doc.referrer ? new URL(doc.referrer).hostname : ''; } catch (e) {}
    var external = refHost && !OWN_HOST.test(refHost) && refHost !== w.location.hostname;
    var source = q.utm_source || (external ? refHost : '') || 'direct';
    return {
      source: source,
      medium: q.utm_medium || (q.gclid ? 'cpc' : external ? 'referral' : ''),
      campaign: q.utm_campaign || '',
      content: q.utm_content || '',
      term: q.utm_term || '',
      utm_id: q.utm_id || '',
      ad_id: q.ad_id || '',
      gclid: q.gclid || '',
      fbclid: q.fbclid || '',
      landing: w.location.pathname,
      at: new Date().toISOString(),
      _signal: !!(q.utm_source || q.gclid || q.fbclid || (external && !SHOPIFY_HOST.test(refHost)))
    };
  }

  var touchNow = readTouch();
  // 이 방문의 유입 — 광고·외부에서 새로 들어왔으면 갈아 끼운다. 사이트 안 이동은 유지한다
  /* ★새 탭(target=_blank · rel=noopener)에는 sessionStorage 가 안 넘어간다 〔2026-11-02 · 광고 랜딩 실측〕
     → 새 탭이 «direct» 로 다시 적고, 그 탭에서 연 Calendly 에 옛 첫 유입이 붙었다.
     그래서 분석 동의가 있으면 localStorage 에 30분짜리 사본(squid_session_touch_shared)을 두고,
     sessionStorage 가 빈 탭이 «새 신호 없이» 열리면 그 사본을 이어 받는다. 30분은 GA4 세션 시간 기본값과 같다.
     읽기는 첫 유입(squid_first_touch)처럼 동의 확인 없이 — 쓰기는 동의가 있을 때만 (persistFirstTouch 와 같은 꼴). */
  var SHARED_TOUCH_KEY = 'squid_session_touch_shared';
  var SHARED_TOUCH_TTL = 30 * 60 * 1000;
  var sessionTouch = readJson(session, 'squid_session_touch');
  if (!sessionTouch && !touchNow._signal) {
    var sharedTouch = readJson(local, SHARED_TOUCH_KEY);
    if (sharedTouch && sharedTouch.touch && Date.now() - (sharedTouch.seen || 0) < SHARED_TOUCH_TTL) {
      sessionTouch = sharedTouch.touch;
      writeJson(session, 'squid_session_touch', sessionTouch);
    }
  }
  if (!sessionTouch || touchNow._signal) {
    sessionTouch = touchNow;
    writeJson(session, 'squid_session_touch', sessionTouch);
  }
  function shareSessionTouch() {
    if (analyticsAllowed() !== true || !local) return;
    writeJson(local, SHARED_TOUCH_KEY, { touch: sessionTouch, seen: Date.now() });
  }
  shareSessionTouch();
  doc.addEventListener('visitorConsentCollected', shareSessionTouch);
  w.addEventListener('load', shareSessionTouch);
  // 오래 머문 뒤 새 탭을 열어도 이어지게 — 누를 때마다 시각을 새로 찍는다
  // ★click 만으로는 모자란다 — 휴대폰에서 길게 눌러 «새 탭에서 열기» · 마우스 가운데 버튼은 click 이 안 뜬다
  //   → 손가락·마우스가 닿는 순간(pointerdown)에도 찍는다 (키보드로 여는 것은 click 이 뜬다)
  doc.addEventListener('pointerdown', shareSessionTouch, true);
  doc.addEventListener('click', shareSessionTouch, true);
  var firstTouch = readJson(local, 'squid_first_touch') || readJson(session, 'squid_first_touch_pending');
  if (!firstTouch) {
    firstTouch = touchNow;
    writeJson(session, 'squid_first_touch_pending', firstTouch);
  }
  function persistFirstTouch() {
    if (analyticsAllowed() !== true || !local) return;
    if (!readJson(local, 'squid_first_touch')) writeJson(local, 'squid_first_touch', firstTouch);
    try { session && session.removeItem('squid_first_touch_pending'); } catch (e) {}
  }
  persistFirstTouch();
  doc.addEventListener('visitorConsentCollected', persistFirstTouch);
  w.addEventListener('load', persistFirstTouch);

  // 사용자 속성(first_touch.*) — GTM gtes 가 읽는다. 36자 한도(GA4 사용자 속성)
  function cut36(v) { return v ? String(v).slice(0, 36) : undefined; }
  dl.push({
    first_touch: {
      first_source: cut36(firstTouch.source),
      first_medium: cut36(firstTouch.medium),
      first_campaign: cut36(firstTouch.campaign),
      first_content: cut36(firstTouch.content),
      first_landing: cut36(firstTouch.landing),
      first_seen_at: cut36(firstTouch.at)
    }
  });

  function firstParams() {
    return {
      first_source: firstTouch.source,
      first_campaign: firstTouch.campaign,
      first_landing: (firstTouch.landing || '').slice(0, 100)
    };
  }

  /* ───────── 요소 해석 (beconnow elementDescriptor.ts) ───────── */
  var INTERACTIVE_SELECTOR = [
    'a[href]', 'button', 'summary', '[data-track]',
    "input[type='submit']", "input[type='button']", "input[type='reset']",
    "input[type='checkbox']", "input[type='radio']", "input[type='file']",
    "[role='button']", "[role='link']", "[role='tab']", "[role='menuitem']",
    "[role='menuitemcheckbox']", "[role='menuitemradio']", "[role='option']",
    "[role='switch']", "[role='checkbox']", "[role='radio']",
    /* ★GB 에서 더한 칸 — 버튼 노릇을 하는데 버튼 태그가 아닌 테마·앱 부품 (2026-09-25 사각지대 전수 — 손가락 커서인데 위 목록 밖).
       여기 없으면 눌러도 ui_click 이 안 나가고 전수에도 안 보인다. 카드의 담기·옵션 고르기가 그랬다 */
    'add-to-cart', 'quick-view-button', 'img.deferred-media__poster', '.reelfy_card_play', 'li.dot'
  ].join(', ');
  var TYPING_SELECTOR = [
    "input:not([type='checkbox']):not([type='radio']):not([type='submit']):not([type='button']):not([type='reset']):not([type='file'])",
    'textarea', 'select', "[contenteditable='']", "[contenteditable='true']"
  ].join(', ');
  var ELEMENT_ID_TEXT_MAX = 40;
  var ELEMENT_TEXT_MAX = 100;
  var LINK_URL_MAX = 100;
  var GENERATED_ID = /:|^(radix|headlessui|react|mui)-|^[a-z0-9]{12,}$/i;
  // Shopify 가 만드는 id — 섹션 id(template--123__main)·블록 id 가 붙어 있어 템플릿을 고치면 바뀐다
  var SHOPIFY_ID = /(template|sections)--\d+__|__[A-Za-z0-9]{6,}$|\d{8,}/;
  var EMAIL_PATTERN = /[\w.+-]+@[\w-]+\.[\w.-]+/g;
  var PHONE_PATTERN = /\+?\d[\d\s-]{7,}\d/g;

  function maskPersonalText(t) { return t.replace(EMAIL_PATTERN, '*').replace(PHONE_PATTERN, '*'); }
  function normalizeText(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function isInputLike(el) { return /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName); }

  function resolveClickTarget(target) {
    var label = target.closest('label');
    var base = (label && label.control) || target;
    return { interactive: base.closest(INTERACTIVE_SELECTOR), typing: base.closest(TYPING_SELECTOR) !== null };
  }

  // ★<noscript> 안은 JS 가 켜져 있으면 «글자»로 읽힌다 — 모바일 필터 제목이 `Price <svg xmlns=…` 로 나갔다 (2026-09-25 전수)
  var NOT_TEXT = 'noscript, script, style, template';
  function visibleText(el) {
    if (!el.querySelector(NOT_TEXT)) return el.textContent;
    var copy = el.cloneNode(true);
    Array.prototype.forEach.call(copy.querySelectorAll(NOT_TEXT), function (n) { n.parentNode.removeChild(n); });
    return copy.textContent;
  }

  function readElementText(el) {
    if (el.closest('[data-private]')) return '';
    var rule = ruleOf(el);
    if (rule && rule.text) return normalizeText(rule.text(el)).slice(0, ELEMENT_TEXT_MAX);
    if (isInputLike(el)) return '';
    var text = normalizeText(visibleText(el));
    if (!text) {
      var img = el.querySelector('img[alt]');
      text = img ? img.getAttribute('alt') || '' : '';
    }
    return maskPersonalText(text).slice(0, ELEMENT_TEXT_MAX);
  }

  function fallbackElementId(el) {
    var tag = el.tagName.toLowerCase();
    var text = readElementText(el).slice(0, ELEMENT_ID_TEXT_MAX);
    return text ? tag + ':' + text : tag;
  }

  /* ★주소에 열쇠가 든 경로 — 주문 상세·계정 활성화·비밀번호 재설정 (2026-09-25 로그인 전수).
     link: 이름과 link_url 에 토큰이 그대로 실렸다. 꼴만 남긴다 (snippets/squid-analytics.liquid 의 canonical_path 와 같은 꼴) */
  var SECRET_PATH = /^\/account\/(orders|activate|reset)\/.+$/;
  function maskPath(p) {
    var m = SECRET_PATH.exec(p || '');
    return m ? '/account/' + m[1] + '/:token' : p;
  }

  /* ★GB 에서 더한 칸 — 링크는 주소가 이름이다.
     글자 폴백은 문구를 고치면 이름이 바뀐다. 경로는 문구와 무관하다 (스토어가 영어 하나라 언어로는 안 갈린다). */
  function linkName(el) {
    if (el.tagName !== 'A') return null;
    var raw = el.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^javascript:/i.test(raw)) return null;
    var u;
    try { u = new URL(el.href, w.location.href); } catch (e) { return null; }
    if (u.protocol === 'mailto:') return 'mailto';
    if (u.protocol === 'tel:') return 'tel';
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
    if (OWN_HOST.test(u.hostname) || u.hostname === w.location.hostname) return ('link:' + maskPath(u.pathname || '/')).slice(0, LINK_URL_MAX);
    return ('out:' + u.hostname).slice(0, LINK_URL_MAX);
  }

  /* ★GB 에서 더한 칸 — 테마 부품 이름표 (2026-09-25 전수에서 글자 폴백으로 떨어지던 자리)
     Liquid 여기저기에 data-track 을 다는 대신 이 한 곳에 둔다 — 테마 저장소는 라이브 테마를 따라가서, 계측이 우리 파일 둘
     (snippets/squid-analytics.liquid · 이 파일)에만 있어야 테마를 받을 때 안 덮인다.
     판정 순서: data-track → ★이 표 → id → aria-label → name → 링크 → 글자 폴백. 위에서부터 먼저 맞는 줄이 이긴다.
     이름은 「대상:동작」 — 코드값만 넣고 화면 글자는 안 넣는다. 글자는 element_text 로 따로 간다 (계측.yaml 클릭_이름.이름_규칙).
       pos  — 같은 섹션 안에서 같은 줄에 맞는 것 중 몇 번째인가 → position (사진 몇 번째 · 질문 몇 번째)
       text — element_text 를 이걸로 (입력칸은 글자를 안 읽는다 — 옵션 값처럼 개인정보가 아닌 것만)
     ★테마 클래스가 바뀌면 조용히 글자 폴백으로 돌아간다 — 누를 자리 전수로 잰다 (squid 문서/참고 GB 전수). */
  function filterKey(el) {
    var m = /filter\.(?:[vp]\.)?(.+?)-(?:template|sections)--/.exec((el.parentElement && el.parentElement.id) || '');
    return m ? m[1].replace(/[^a-z0-9]+/gi, '_').toLowerCase() : 'other';
  }
  // 장바구니 서랍의 동작 넷(선물 메모 · 메모 · 배송비 계산 · 할인) — 제목 글자가 아니라 안에 든 부품으로 가른다
  function cartActionKey(el) {
    var d = el.closest('details');
    if (!d) return 'other';
    if (d.querySelector('gift-note')) return 'gift_note';
    if (d.querySelector('cart-note')) return 'note';
    if (d.querySelector('[data-discount-btn]')) return 'discount';
    if (d.querySelector('shipping-calculator, [name="address[country]"], [id*="shipping" i]')) return 'shipping_calc';
    return 'other';
  }
  var NAME_RULES = [
    { sel: 'a.skip-to-content-link[href="#MainContent"]', name: 'a11y:skip_to_content' },
    { sel: 'a.skip-to-content-link[href^="#ProductInfo"]', name: 'a11y:skip_to_product_info' },
    { sel: 'localization-form button.disclosure__button', name: function (el) { return /country/i.test(el.getAttribute('aria-controls') || '') ? 'localization:country' : 'localization:language'; } },
    { sel: 'footer-accordion.footer-block--newsletter summary', name: 'footer:newsletter_toggle' },
    { sel: 'footer-accordion summary', name: 'footer:menu_toggle', pos: true },
    { sel: 'button.product__media-toggle', name: 'media:zoom', pos: true },
    { sel: '.deferred-media__poster', name: 'media:play_video', pos: true },
    { sel: '.reelfy_card_play', name: 'reelfy:play', pos: true },
    { sel: 'li.dot', name: 'carousel:dot', pos: true },
    { sel: 'variant-selects input[type="radio"]', name: 'pdp:variant_option', text: function (el) { return el.value; } },
    { sel: 'share-button button', name: 'share:open' },
    { sel: 'accordion-tab.product__accordion summary', name: 'pdp:info_tab', pos: true },
    { sel: 'accordion-tab summary', name: 'accordion:toggle', pos: true },
    { sel: 'details.js-filter > summary', name: function (el) { return ('filter:open_' + filterKey(el)).slice(0, ELEMENT_ID_TEXT_MAX); } },
    { sel: 'details.facet-filters__sort > summary', name: 'filter:open_sort' },
    { sel: 'facet-drawer > details > summary', name: 'filter:open_drawer' },
    { sel: '.mobile-facets__footer button', name: 'filter:apply' },
    { sel: 'button.list-view__item', name: function (el) { return 'plp:layout_' + (el.getAttribute('data-layout-mode') || '').replace(/[^a-z0-9]+/gi, '_'); } },
    { sel: 'add-to-cart, .card-information__button button', name: 'card:add_to_cart' },
    { sel: 'quick-view-button', name: 'card:choose_options' },
    { sel: '.image-with-text__products > button', name: 'bundle:add_to_cart' },
    { sel: 'form.contact-form button[type="submit"]', name: 'contact:send' },
    { sel: 'form#customer_login button[type="submit"]', name: 'auth:login' },
    { sel: 'form#create_customer button[type="submit"]', name: 'auth:register' },
    { sel: 'a[href="#recover"]', name: 'auth:forgot_password' },
    { sel: '[data-discount-btn]', name: 'cart:discount_apply' },
    // ★2026-09-25 로그인·서랍 전수에서 더함
    { sel: '.mini-cart__action > summary', name: function (el) { return 'cart:' + cartActionKey(el) + '_open'; } },
    { sel: '.mini-cart__action button.close', name: function (el) { return 'cart:' + cartActionKey(el) + '_close'; } },
    { sel: 'button[is="discount-remove"]', name: 'cart:discount_remove' },
    { sel: 'a.delete-product, cart-remove-button a, cart-remove-button button', name: 'cart:remove', pos: true },
    { sel: '.mini-cart__action button', name: function (el) { return 'cart:' + cartActionKey(el) + '_submit'; } },
    { sel: '.shopify-payment-button__button--unbranded, .shopify-payment-button__button', name: 'pdp:buy_now' },
    { sel: '.shopify-payment-button__more-options', name: 'pdp:more_payment_options' },
    { sel: '#RowOrder a, a[href*="/account/orders/"]', name: 'account:order_open', pos: true },
    { sel: 'button[aria-controls="AddAddress"]', name: 'account:address_new' },
    { sel: 'button[id^="EditFormButton_"]', name: 'account:address_edit', pos: true },
    { sel: 'button[data-target*="/account/addresses/"]', name: 'account:address_delete', pos: true },
    { sel: 'form[id^="address_form_"] button[type="submit"]', name: 'account:address_save' },
    { sel: 'form[id^="address_form_"] button[type="reset"]', name: 'account:address_cancel' },
    { sel: 'form[id^="address_form_"] input[name="address[default]"]', name: 'account:address_default' },
    { sel: 'form[action*="/account/recover"] button[type="submit"], #RecoverPassword button[type="submit"]', name: 'auth:recover_submit' },
    { sel: 'a[href="#login"]', name: 'auth:recover_cancel' },
    { sel: '[class*="kl-teaser"] [role="button"]', name: 'klaviyo:teaser_open' },
    { sel: 'button.klaviyo-close-form', name: 'klaviyo:form_close' },
    // Klaviyo 가입창 버튼 — 가입·거절이 구조로 안 갈린다(둘 다 type=button · data-action-id 는 창 판마다 바뀐다).
    //   몇 번째 버튼인가(position)와 글자(element_text)로 읽는다. 가입 «성공»은 newsletter_signup 이 따로 센다
    { sel: 'form.klaviyo-form button', name: 'klaviyo:form_button', pos: true },
    { sel: 'header li > details > summary', name: 'nav:submenu_toggle', pos: true },
    { sel: 'summary.quick-view__summary', name: 'card:quick_view_toggle' }
  ];
  function ruleOf(el) {
    if (!el || !el.matches) return null;
    for (var i = 0; i < NAME_RULES.length; i += 1) {
      try { if (el.matches(NAME_RULES[i].sel)) return NAME_RULES[i]; } catch (e) {}
    }
    return null;
  }
  function ruleName(rule, el) {
    return typeof rule.name === 'function' ? rule.name(el) : rule.name;
  }

  function resolveElementId(el) {
    var track = el.getAttribute('data-track') || el.getAttribute('data-ux-area');
    if (track) return { id: track, named: true };
    var rule = ruleOf(el);
    if (rule) return { id: ruleName(rule, el), named: true };
    if (el.id && !GENERATED_ID.test(el.id) && !SHOPIFY_ID.test(el.id)) return { id: el.id, named: true };
    var aria = el.getAttribute('aria-label');
    if (aria) return { id: aria.slice(0, ELEMENT_ID_TEXT_MAX), named: true };
    var name = el.getAttribute('name');
    if (name && !isInputLike(el)) return { id: name, named: true };
    var link = linkName(el);
    if (link) return { id: link, named: true };
    return { id: fallbackElementId(el), named: false };
  }

  /* 섹션 — [data-section] → Shopify 섹션 감싸개의 키
     `shopify-section-template--26837864317218__image_banner_rWnjpF` → `image_banner_rWnjpF`
     키는 템플릿 안에서 고정이다 (screen_key 와 같이 보면 어느 페이지의 어느 섹션인지 갈린다). */
  // ★감싸개만 — `<main id="MainContent" class="shopify-section">` 가 본문 전체를 한 섹션으로 잡았다 (09-25 미리보기)
  var SECTION_SELECTOR = '[data-section], .shopify-section[id^="shopify-section-"]';
  function sectionKey(el) {
    // ★이 테마는 안쪽 요소에 data-section="{{ section.id }}" 를 단다 — 값이 `template--28193875820834__main` 꼴이라 꼬리만 쓴다 (2026-09-25 전수)
    var named = el.getAttribute('data-section');
    if (named) return named.replace(/^(?:template|sections)--\d+__/, '');
    var id = el.id || '';
    var m = /^shopify-section-(?:template|sections)--\d+__(.+)$/.exec(id);
    if (m) return m[1];
    return id.replace(/^shopify-section-/, '') || null;
  }
  function readSectionName(el) {
    var s = el.closest(SECTION_SELECTOR);
    return s ? sectionKey(s) || undefined : undefined;
  }

  function readPosition(el) {
    var explicit = el.getAttribute('data-position');
    if (explicit !== null) {
      var n = Number(explicit);
      return isFinite(n) ? n : undefined;
    }
    var track = el.getAttribute('data-track');
    if (!track) {
      var rule = ruleOf(el);
      if (!rule || !rule.pos) return undefined;
      var scope = el.closest(SECTION_SELECTOR) || doc;
      // 보이는 것끼리만 센다 — 모바일 서랍과 데스크톱 메뉴가 같은 섹션에 둘 다 있어 숨은 쪽까지 세면 번호가 밀린다
      var mates = Array.prototype.filter.call(scope.querySelectorAll(rule.sel), function (x) {
        return ruleOf(x) === rule && (x === el || x.getBoundingClientRect().width > 0);
      });
      if (mates.length < 2) return undefined;
      var at = mates.indexOf(el);
      return at >= 0 ? at + 1 : undefined;
    }
    var same = doc.querySelectorAll('[data-track="' + (w.CSS && CSS.escape ? CSS.escape(track) : track.replace(/["\\]/g, '\\$&')) + '"]');
    if (same.length < 2) return undefined;
    var idx = Array.prototype.indexOf.call(same, el);
    return idx >= 0 ? idx + 1 : undefined;
  }

  function readLinkUrl(el) {
    if (el.tagName !== 'A' || !el.getAttribute('href')) return undefined;
    try {
      var u = new URL(el.href, w.location.href);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return undefined;
      return (u.origin + maskPath(u.pathname)).slice(0, LINK_URL_MAX);
    } catch (e) { return undefined; }
  }

  function isDisabled(el) { return el.getAttribute('aria-disabled') === 'true' || el.hasAttribute('disabled'); }

  function clickPercent(ev) {
    function pct(v, total) { return total > 0 ? Math.min(100, Math.max(0, Math.round((v / total) * 100))) : 0; }
    return { click_x_pct: pct(ev.clientX, w.innerWidth), click_y_pct: pct(ev.clientY, w.innerHeight) };
  }

  function assign(a, b) { Object.keys(b).forEach(function (k) { a[k] = b[k]; }); return a; }

  /* ───────── ui_click · dead_click (beconnow installClickAnalytics.ts) ───────── */
  var DUPLICATE_WINDOW_MS = 50;
  var DEAD_CLICK_WAIT_MS = 700;
  var DEAD_CLICK_ATTRIBUTES = ['class', 'hidden', 'open', 'aria-expanded', 'aria-selected', 'aria-checked', 'aria-pressed', 'aria-hidden', 'data-state'];
  var DEAD_CLICK_SCOPE_DEPTH = 4;

  function deadClickScope(target) {
    var node = target;
    for (var i = 0; i < DEAD_CLICK_SCOPE_DEPTH; i += 1) {
      var parent = node.parentElement;
      if (!parent || parent === doc.body || parent === doc.documentElement) break;
      node = parent;
    }
    return node;
  }

  var lastClick = null;
  var pendingDead = null;

  function cancelDeadWatch() {
    if (!pendingDead) return;
    w.clearTimeout(pendingDead.timer);
    pendingDead.observer.disconnect();
    pendingDead = null;
  }

  function watchDeadClick(target, ev) {
    cancelDeadWatch();
    var href = w.location.href;
    var active = doc.activeElement;
    var pos = clickPercent(ev);
    var mutated = false;
    var observer = new MutationObserver(function () { mutated = true; });
    observer.observe(deadClickScope(target), {
      childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: DEAD_CLICK_ATTRIBUTES
    });
    var timer = w.setTimeout(function () {
      observer.disconnect();
      pendingDead = null;
      if (mutated || w.location.href !== href || doc.activeElement !== active) return;
      var sel = w.getSelection ? String(w.getSelection()) : '';
      if (sel.length > 0) return;
      pushEvent('dead_click', assign({
        element_id: fallbackElementId(target),
        element_text: readElementText(target),
        section_name: readSectionName(target)
      }, pos));
    }, DEAD_CLICK_WAIT_MS);
    pendingDead = { timer: timer, observer: observer };
  }

  /* ★shadow DOM 안을 누른 것 — 클릭 대상이 감싸개(호스트)로 바뀌어 온다. Shop 앱 버튼(shop-login-button ·
     shop-follow-button · shop-pay-wallet-button)이 이렇다 (2026-09-25 전수). 호스트는 인터랙티브 목록에 없어서
     그대로 두면 「헛클릭」으로 잘못 센다 → 호스트 태그 이름을 이름으로 ui_click 을 낸다. */
  function shadowHost(ev, target) {
    if (!target.shadowRoot || !ev.composedPath) return null;
    var path = ev.composedPath();
    return path.length && path[0] !== target ? target : null;
  }

  function onClick(ev) {
    // ★GB 에서 더한 줄 — 사람이 누른 것만 센다. 이 테마는 부품이 숨은 summary 를 코드로 대신 누른다(quick-view-button →
    //   quick-view summary). 그걸 세면 한 번 누른 게 두 번(`card:choose_options` + `summary:Quick view`)으로 나갔다 (2026-09-25).
    //   label 을 눌러 입력칸에 가는 클릭은 브라우저가 만든 것이라 isTrusted 가 참이다 — 안 빠진다.
    if (ev.isTrusted === false) return;
    var target = ev.target && ev.target.nodeType === 1 ? ev.target : null;
    if (!target || target.closest('[data-track-ignore]')) return;
    var host = shadowHost(ev, target);
    if (host) {
      authIntent(host.tagName.toLowerCase());
      pushEvent('ui_click', assign({
        element_id: host.getAttribute('data-track') || host.tagName.toLowerCase(),
        element_text: normalizeText(host.getAttribute('aria-label') || '').slice(0, ELEMENT_TEXT_MAX),
        section_name: readSectionName(host)
      }, clickPercent(ev)));
      return;
    }
    var r = resolveClickTarget(target);
    if (r.typing) return;
    if (!r.interactive) {
      if (ev.detail > 1 || target.closest('video, audio, canvas, iframe')) return;
      watchDeadClick(target, ev);
      return;
    }
    var now = w.performance && performance.now ? performance.now() : Date.now();
    if (lastClick && lastClick.element === r.interactive && now - lastClick.at < DUPLICATE_WINDOW_MS) return;
    lastClick = { element: r.interactive, at: now };

    var el = r.interactive;
    pushEvent('ui_click', assign({
      element_id: resolveElementId(el).id,
      element_text: readElementText(el),
      section_name: readSectionName(el),
      position: readPosition(el),
      link_url: readLinkUrl(el),
      disabled: isDisabled(el)
    }, clickPercent(ev)));
  }

  /* ───────── rage_click (beconnow useRageClick.ts — 3회 · 1000ms · 24px) ───────── */
  var RAGE_THRESHOLD = 3;
  var RAGE_WINDOW_MS = 1000;
  var RAGE_RADIUS = 24;
  var rage = { count: 0, at: 0, x: 0, y: 0, target: null };

  function onRageClick(ev) {
    if (ev.isTrusted === false) return; // onClick 과 같다 — 코드가 누른 것은 연타가 아니다
    var target = ev.target && ev.target.nodeType === 1 ? ev.target : null;
    if (!target) return;
    var now = ev.timeStamp;
    var near = Math.abs(ev.clientX - rage.x) <= RAGE_RADIUS && Math.abs(ev.clientY - rage.y) <= RAGE_RADIUS;
    var sameSpot = near && (rage.target === target || (rage.target && rage.target.contains(target)));
    rage.count = sameSpot && now - rage.at <= RAGE_WINDOW_MS ? rage.count + 1 : 1;
    rage.at = now;
    rage.x = ev.clientX;
    rage.y = ev.clientY;
    rage.target = target;
    if (rage.count !== RAGE_THRESHOLD) return;

    var r = resolveClickTarget(target);
    var el = r.interactive || target;
    pushEvent('rage_click', assign({
      rage_area: r.interactive ? resolveElementId(el).id : fallbackElementId(target),
      rage_count: rage.count,
      element_text: readElementText(el),
      section_name: readSectionName(target)
    }, clickPercent(ev)));
  }

  /* ───────── section_view (beconnow installSectionAnalytics.ts) ─────────
     보이는 높이가 섹션 높이 또는 뷰포트 높이의 절반 이상일 때, 페이지에서 섹션당 1회. */
  var seenSections = {};
  var sectionIO = null;
  function installSections() {
    if (typeof IntersectionObserver === 'undefined') return;
    var thresholds = [];
    for (var i = 0; i <= 10; i += 1) thresholds.push(i / 10);
    sectionIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var name = sectionKey(entry.target);
        if (!name || seenSections[name]) return;
        var sectionHeight = entry.boundingClientRect.height;
        var visibleHeight = entry.intersectionRect.height;
        var viewportHeight = entry.rootBounds ? entry.rootBounds.height : w.innerHeight;
        if (sectionHeight <= 0 || visibleHeight <= 0) return;
        if (visibleHeight >= 0.5 * Math.min(sectionHeight, viewportHeight)) {
          seenSections[name] = 1;
          pushEvent('section_view', { section_name: name });
        }
      });
    }, { threshold: thresholds });
    var observeAll = function () { doc.querySelectorAll(SECTION_SELECTOR).forEach(function (el) { sectionIO.observe(el); }); };
    observeAll();
    var debounce = 0;
    new MutationObserver(function () {
      w.clearTimeout(debounce);
      debounce = w.setTimeout(observeAll, 200);
    }).observe(doc.body, { childList: true, subtree: true });
  }

  /* ───────── scroll_depth (beconnow installScrollAnalytics.ts — 25·50·75·100 · 스크롤 없는 화면은 안 센다) ───────── */
  var DEPTH_POINTS = [25, 50, 75, 100];
  var reached = {};
  var frame = 0;
  var pendingScroll = null;
  function measureScroll(p) {
    var el = p.element;
    var scrollHeight = el ? el.scrollHeight : doc.documentElement.scrollHeight;
    var clientHeight = el ? el.clientHeight : doc.documentElement.clientHeight;
    var scrollable = scrollHeight - clientHeight;
    if (scrollable <= 0) return;
    var offset = el ? el.scrollTop : w.scrollY || doc.documentElement.scrollTop || 0;
    var percent = Math.round((offset / scrollable) * 100);
    var points = reached[p.root] || (reached[p.root] = {});
    DEPTH_POINTS.forEach(function (point) {
      if (percent < point || points[point]) return;
      points[point] = 1;
      pushEvent('scroll_depth', { percent_scrolled: point, scroll_root: p.root });
    });
  }
  function onScroll(ev) {
    var t = ev.target;
    var next;
    if (t === doc || t === w) next = { root: 'window', element: null };
    else if (t && t.nodeType === 1 && t.hasAttribute('data-scroll-root')) next = { root: t.getAttribute('data-scroll-root') || 'root', element: t };
    else return;
    pendingScroll = next;
    if (frame) return;
    frame = w.requestAnimationFrame(function () {
      frame = 0;
      if (pendingScroll) measureScroll(pendingScroll);
      pendingScroll = null;
    });
  }

  /* ───────── 데모콜 (Calendly) ─────────
     팝업·인라인 둘 다 Calendly 가 부모 창으로 postMessage(calendly.*) 를 보낸다 — 우리 페이지에서 받아 사전 이름으로.
     단계: 0 popup_open(팝업만) · 1 event_type_viewed · 2 date_time_selected · 3 scheduled → generate_lead{demo_call}
     ★예약 창이 무엇이냐로 가른다 (2026-09-28) — 사이트에는 데모 팀 창과 온보딩 팀 창(산 손님의 사용법 안내)이 뜬다.
       funnel_name 이 demo_call · onboarding_call · other_call 로 갈리고, generate_lead 는 demo_call 에만 쏜다 (리드는 데모만 · 설계 3-I).
       09-28 실측: 옛 demo_scheduled 90일 133건 중 48건이 온보딩 신청 페이지에서 찍혔다 — 온보딩이 Ads 전환으로 섞이고 있었다.
       가르는 자리는 Calendly iframe 주소의 첫 조각(팀·사람 이름). 데모 링크의 정본은 squid 레지스트리/계측.yaml 사이트.GB.데모콜
     ★2026-09-30 데모 리드는 이 generate_lead 하나다 — GTM 「Calendly Listener」 → demo_scheduled 는 걷었다 (GTM v15).
       Google Ads US DEMO · 메타 Schedule · LinkedIn 전환이 전부 GTM 「Event - generate_lead」 로 이것을 받는다 (demo-es/it 폼 demo_form 도).
     ★Calendly 는 예약 URL 의 utm_* 를 초대자 기록에 남긴다 → 이 방문의 유입(없으면 첫 유입)을 실어 보낸다. */
  var CALENDLY_ORIGIN = /^https:\/\/([a-z0-9-]+\.)?calendly\.com$/i;
  var CALENDLY_KINDS = { 'becon-global-demo-call': 'demo_call', 'global-onboarding': 'onboarding_call' };
  function calendlyKind(url) {
    try {
      var seg = (new URL(url, w.location.href).pathname.split('/')[1] || '').toLowerCase();
      return CALENDLY_KINDS[seg] || 'other_call';
    } catch (e) { return 'other_call'; }
  }
  var CALENDLY_STEPS = {
    'calendly.event_type_viewed': [1, 'event_type_viewed'],
    'calendly.date_and_time_selected': [2, 'date_time_selected'],
    'calendly.event_scheduled': [3, 'scheduled']
  };
  var calendlySeen = {};

  function calendlyUtm() {
    var t = sessionTouch && sessionTouch._signal ? sessionTouch : firstTouch;
    var map = { utm_source: t.source, utm_medium: t.medium, utm_campaign: t.campaign, utm_content: t.content, utm_term: t.term };
    if (!map.utm_source || map.utm_source === 'direct') return null;
    return map;
  }
  function withUtm(url) {
    var utm = calendlyUtm();
    if (!utm || !url) return url;
    try {
      var u = new URL(url, w.location.href);
      Object.keys(utm).forEach(function (k) { if (utm[k] && !u.searchParams.get(k)) u.searchParams.set(k, utm[k]); });
      return u.toString();
    } catch (e) { return url; }
  }

  function calendlyFrame(source) {
    var frames = doc.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i += 1) {
      if (frames[i].contentWindow === source) return frames[i];
    }
    return null;
  }
  /* 테마가 직접 띄우는 OpenAI 전환(layout/theme.liquid)도 이 기준으로 데모만 센다 (2026-10-02 · 온보딩 제외) */
  cfg.calendlyKindOf = function (source) { var f = calendlyFrame(source); return calendlyKind(f && f.src); };

  function onCalendlyMessage(ev) {
    if (!ev || !CALENDLY_ORIGIN.test(ev.origin || '')) return;
    var data = ev.data;
    if (!data || typeof data.event !== 'string' || data.event.indexOf('calendly.') !== 0) return;
    var step = CALENDLY_STEPS[data.event];
    if (!step) return;

    var frameEl = calendlyFrame(ev.source);
    var inline = frameEl && frameEl.closest('.calendly-inline-widget');
    var origin = inline ? 'inline' : 'popup';
    var sectionName = inline ? readSectionName(inline) : undefined;
    var kind = calendlyKind(frameEl && frameEl.src);
    var key = kind + ':' + origin + ':' + (sectionName || '') + ':' + step[0];
    if (step[0] < 3 && calendlySeen[key]) return;
    calendlySeen[key] = 1;

    pushEvent('funnel_step', {
      funnel_name: kind, step_number: step[0], step_name: step[1], step_origin: origin, section_name: sectionName
    });
    if (step[0] === 3 && kind === 'demo_call') {
      var uri = data.payload && data.payload.event && data.payload.event.uri;
      pushEvent('generate_lead', assign({
        lead_type: 'demo_call',
        form_id: 'calendly_' + origin,
        reservation_id: uri ? String(uri).split('/').pop().slice(0, 100) : undefined,
        section_name: sectionName
      }, firstParams()));
    }
  }

  function patchInlineWidgets() {
    doc.querySelectorAll('.calendly-inline-widget[data-url]').forEach(function (el) {
      if (el.getAttribute('data-squid-utm')) return;
      el.setAttribute('data-squid-utm', '1');
      el.setAttribute('data-url', withUtm(el.getAttribute('data-url')));
      // widget.js 가 먼저 떠서 iframe 이 이미 있으면 그 주소에도 싣는다 (한 번 다시 읽힌다)
      var frameEl = el.querySelector('iframe');
      if (frameEl && frameEl.src && calendlyUtm()) frameEl.src = withUtm(frameEl.src);
    });
  }

  /* ★«감쌌나»는 Calendly 객체의 표시가 아니라 «지금 함수가 우리 것인가»로 본다 〔2026-11-02 실측〕
     Calendly 달력을 박은 상품 템플릿(product.*.json)이 widget.js 를 한 번 더 싣는다 → 두 번째 실림이 우리 감싸기 뒤에 끝나면
     initPopupWidget 을 원래 함수로 덮고, 객체 표시(__squidWrapped)는 남아 다시 감싸지 않았다 → 팝업 달력에 utm 이 안 붙었다
     (랜딩 → 같은 탭으로 상품 페이지 · 캐시가 데워진 이동에서 3/3 · 바로 열 때는 순서가 달라 안 났다).
     그래서 함수 자체에 표시를 달고, 누를 때마다(pointerdown · click 잡기 단계 — 페이지의 버튼 처리보다 먼저) 다시 본다. */
  function wrapCalendlyPopup() {
    var C = w.Calendly;
    if (!C || typeof C.initPopupWidget !== 'function') return false;
    if (C.initPopupWidget.__squidWrapper) return true;
    var original = C.initPopupWidget;
    var wrapper = function (opts) {
      try { if (opts && opts.url) opts.url = withUtm(opts.url); } catch (e) {}
      pushEvent('funnel_step', { funnel_name: calendlyKind(opts && opts.url), step_number: 0, step_name: 'popup_open', step_origin: 'popup' });
      return original.apply(C, arguments);
    };
    wrapper.__squidWrapper = true;
    C.initPopupWidget = wrapper;
    C.__squidWrapped = true;
    return true;
  }

  /* ───────── 폼 제출 — 데모 폼 · 일반 문의 · 뉴스레터 ─────────
     Shopify 폼은 보내고 나면 ?contact_posted=true(문의) · ?customer_posted=true(뉴스레터) 로 돌아온다 — 그 착지를 성공으로 센다.
     실패하면 이 꼬리표 없이 오류 문구와 함께 다시 그려진다 (그건 friction form_error).
     ★성공 문구로 세지 않는다 — Shopify 는 같은 종류 폼 «전부»에 성공을 그린다(posted_successfully? 가 꼬리표를 본다).
       어느 폼이었나는 꼬리표 뒤 #폼id 로 가린다.
     ★리드는 데모만 (2026-09-25 사람 결정 · 설계 3-I) — generate_lead 는 Ads 가 전환으로 통째로 가져간다.
       뉴스레터를 섞으면 광고가 「데모 신청」 대신 「이메일 가입」을 쫓는다. 그래서 일반 문의는 contact_submit ·
       뉴스레터는 newsletter_signup 로 따로 둔다.
     ★옛 GTM 「GA4 - demo_form_submit_es/_it」 은 걷었다 (2026-09-30 GTM v17 · 재욱 「둘 다 같은 데모 콜」) — 스페인·이탈리아 폼도
       이 generate_lead(lead_type demo_form · form_id demo-es|demo-it) 하나로 센다. 광고 계정도 이것 하나다 (US DEMO). */
  var DEMO_FORM_PAGES = { 'demo-es': 1, 'demo-it': 1 };
  var NEWSLETTER_FORMS = { ContactFooter: 'footer', form__popup_newsletter: 'popup' }; // id 없는 것은 newsletter 섹션뿐
  function onceThisLanding(tag) {
    var once = 'squid_' + tag + '_' + w.location.pathname + w.location.search;
    if (session && session.getItem(once)) return false; // 새로고침으로 두 번 세지 않는다
    try { session && session.setItem(once, '1'); } catch (e) {}
    return true;
  }
  function postedFormHash() {
    try { return decodeURIComponent(w.location.hash.slice(1)); } catch (e) { return ''; }
  }
  function checkPostedForms() {
    var search = w.location.search;
    var key = cfg.dims && cfg.dims.screen_key;
    if (/[?&]contact_posted=true(?:&|$)/.test(search) && onceThisLanding('contact')) {
      if (cfg.dims.screen_name === 'page' && DEMO_FORM_PAGES[key]) {
        pushEvent('generate_lead', assign({ lead_type: 'demo_form', form_id: key }, firstParams()));
      } else {
        var form = doc.getElementById(postedFormHash());
        pushEvent('contact_submit', assign({
          form_id: (key || cfg.dims.screen_name || 'contact').slice(0, 40),
          section_name: form ? readSectionName(form) : undefined
        }, firstParams()));
      }
    }
    if (/[?&]customer_posted=true(?:&|$)/.test(search) && onceThisLanding('newsletter')) {
      pushEvent('newsletter_signup', assign({ form_id: NEWSLETTER_FORMS[postedFormHash()] || 'newsletter', method: 'shopify' }, firstParams()));
    }
  }

  /* ───────── 모달·서랍 — modal_view · modal_close (beconnow dialogAnalytics 와 같은 이름·매개변수) ─────────
     이 테마(Be Yours)는 열 때 open 속성을 붙인다 — ModalDialog 꼴은 «요소 자신», MenuDrawer 꼴(cart·facet·header·
     quick-view 서랍)은 «안쪽 첫 details» (assets/global.js 1026·737 · 2026-09-25 읽음). 그 속성 하나로 열림·닫힘을 본다.
     이름은 컴포넌트 태그(cart-drawer → cart_drawer) · modal-dialog 는 여러 벌이라 id 에서 Shopify 섹션 꼬리를 뗀 것. */
  var OVERLAY = {
    'modal-dialog': 'modal', 'product-modal': 'modal', 'details-modal': 'modal', 'search-modal': 'modal',
    'promo-popup': 'modal', 'age-verifier': 'modal', 'password-modal': 'modal',
    'cart-drawer': 'drawer', 'menu-drawer': 'drawer', 'header-drawer': 'drawer', 'facet-drawer': 'drawer',
    'quick-view-drawer': 'drawer', 'pickup-availability-drawer': 'drawer'
  };
  var OVERLAY_SEL = Object.keys(OVERLAY).join(',');
  var closeIntent = { method: null, at: 0 };

  function overlayOf(el) {
    if (!el || el.nodeType !== 1) return null;
    var tag = el.tagName.toLowerCase();
    if (OVERLAY[tag]) return el;
    if (tag === 'details' && el.parentElement) {
      var comp = el.parentElement.closest(OVERLAY_SEL);
      if (comp && comp.querySelector('details') === el) return comp;
    }
    return null;
  }
  function modalName(comp) {
    var tag = comp.tagName.toLowerCase();
    var id = (comp.id || '').replace(/-?(template|sections)--\d+__[A-Za-z0-9_-]+/g, '').replace(/[-_]?\d{6,}/g, '');
    var raw = comp.getAttribute('data-modal-name') || (tag === 'modal-dialog' && id ? id : tag);
    return raw.replace(/[^a-z0-9]+/gi, '_').replace(/^_|_$/g, '').toLowerCase().slice(0, 40);
  }
  function onOverlayMutation(records) {
    records.forEach(function (rec) {
      var comp = overlayOf(rec.target);
      if (!comp) return;
      var isOpen = rec.target.hasAttribute('open');
      var name = modalName(comp);
      var type = OVERLAY[comp.tagName.toLowerCase()];
      if (isOpen && !comp.__squidOpenAt) {
        comp.__squidOpenAt = Date.now();
        pushEvent('modal_view', { modal_name: name, modal_type: type });
      } else if (!isOpen && comp.__squidOpenAt) {
        var dur = Date.now() - comp.__squidOpenAt;
        comp.__squidOpenAt = 0;
        var method = Date.now() - closeIntent.at < 1500 ? closeIntent.method : 'auto';
        pushEvent('modal_close', { modal_name: name, modal_type: type, close_method: method, duration_ms: dur });
      }
    });
  }
  function noteCloseIntent(ev) {
    if (ev.type === 'keyup' || ev.type === 'keydown') {
      if (ev.key === 'Escape' || ev.code === 'Escape') closeIntent = { method: 'dismiss', at: Date.now() };
      return;
    }
    var t = ev.target && ev.target.nodeType === 1 ? ev.target : null;
    if (t && t.closest('[data-close], [id^="ModalClose-"], drawer-close-button, [class*="__close"], [class*="overlay"], modal-dialog')) {
      closeIntent = { method: 'dismiss', at: Date.now() };
    }
  }

  /* ───────── friction — 막힌 자리 (beconnow friction · image_error · js_error 와 같은 이름) ─────────
     품절 · 화면에 뜬 오류 문구 · 폼 오류(제출 뒤 되돌아온 화면) · JS 오류(페이지당 20) · 이미지 깨짐(경로당 1) */
  var JS_ERROR_MAX = 20;
  var jsErrors = 0;
  var failedImages = {};
  var seenFriction = {};
  function friction(context, reason, extra) {
    var key = context + '|' + reason;
    if (seenFriction[key]) return;
    seenFriction[key] = 1;
    pushEvent('friction', assign({ friction_context: context, friction_reason: String(reason || '').slice(0, 100) }, extra || {}));
  }
  function onErrorEvent(ev) {
    var t = ev.target;
    if (t && t !== w && t.nodeType === 1) {
      if (t.tagName !== 'IMG') return; // 스크립트·스타일 실패는 friction 이 아니다 (광고 차단기 등)
      var path;
      try { path = new URL(t.currentSrc || t.src, w.location.href).pathname; } catch (e) { return; }
      if (!path || failedImages[path]) return;
      failedImages[path] = 1;
      friction('image_error', path.slice(-100));
      return;
    }
    // 「Script error.」 는 다른 도메인 스크립트의 오류라 브라우저가 내용을 가린 것 — 고칠 단서가 없어 안 센다
    if (!ev.message || /^Script error\.?$/i.test(ev.message)) return;
    if (jsErrors >= JS_ERROR_MAX) return;
    jsErrors += 1;
    friction('js_error', String(ev.message).replace(/\d{4,}/g, 'n').slice(0, 80));
  }
  // 화면에 뜬 오류 문구 — 장바구니·상품 폼·계정 폼의 알림 자리 (테마가 채우는 자리만 · 글자 100자)
  var ERROR_SEL = '[role="alert"], .form__message, .cart-item__error-text, .product-form__error-message, .errors, .form-message--error';
  /* ★오류가 아닌 것은 뺀다 (2026-10-02 실데이터 오탐) — 테마는 성공 문구에도 .form__message 를 쓴다
     (뉴스레터 «Thanks for subscribing» · 문의 «Thanks for contacting us» · 비밀번호 찾기 — 다 icon-success 를 단다).
     클라비요 폼은 우리 것이 아니고 버튼 글자(«SIGN ME UP!»)가 오류로 잡혔다. 글자가 버튼 글자뿐인 자리도 오류가 아니다. */
  var NOT_ERROR_SEL = '[role="status"], [id$="-success"], .form__message--success';
  var FOREIGN_FORM_SEL = '[data-testid^="klaviyo-form"], .klaviyo-form, [class*="kl-private-reset-css"]';
  function isNotError(el, text) {
    if (el.matches(NOT_ERROR_SEL) || el.querySelector('.icon-success') || el.closest(FOREIGN_FORM_SEL)) return true;
    var btn = el.matches('button, [type="submit"]') ? el : el.querySelector('button, [type="submit"]');
    return !!btn && normalizeText(btn.textContent || btn.value) === text;
  }
  function scanUiErrors() {
    doc.querySelectorAll(ERROR_SEL).forEach(function (el) {
      var r = el.getBoundingClientRect();
      var text = normalizeText(el.textContent);
      if (!text || r.width === 0 || r.height === 0) return;
      if (isNotError(el, text)) return;
      var inForm = el.closest('form');
      friction(inForm && /[?&]form_type=|contact_posted|customer_posted/.test(w.location.search) ? 'form_error' : 'ui_error',
        maskPersonalText(text), { section_name: readSectionName(el) });
    });
  }
  function scanSoldOut() {
    doc.querySelectorAll('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]').forEach(function (b) {
      if (!b.disabled && b.getAttribute('aria-disabled') !== 'true') return;
      var text = normalizeText(b.textContent);
      if (!/sold ?out|unavailable/i.test(text)) return;
      var form = b.closest('form');
      var variant = form && form.querySelector('[name="id"]');
      friction('sold_out', (cfg.dims.screen_key || '') + (variant && variant.value ? ':' + variant.value : ''), { section_name: readSectionName(b) });
    });
  }
  var frictionTimer = 0;
  function scheduleFrictionScan() {
    w.clearTimeout(frictionTimer);
    frictionTimer = w.setTimeout(function () { scanUiErrors(); scanSoldOut(); }, 400);
  }

  /* ───────── login · sign_up — Shopify 계정 (GA4 권장 이름 · beconnow 와 같은 method 칸) ─────────
     성공은 «다음 화면에서 guest → member 로 바뀐 것»으로 본다. 어느 폼을 냈는지는 제출 때 sessionStorage 에 적어 둔다.
     Shop 앱 로그인 버튼(shop-login-button)은 shadow DOM 이라 클릭 때 적는다 (위 shadowHost). */
  function authIntent(kind) {
    if (!session) return;
    try { session.setItem('squid_auth_intent', JSON.stringify({ kind: kind, at: Date.now() })); } catch (e) {}
  }
  function onSubmit(ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM') return;
    var id = f.id || '';
    var action = f.getAttribute('action') || '';
    if (/create_customer|register/i.test(id) || (/\/account\/?$/.test(action) && f.querySelector('[name="customer[password]"]'))) authIntent('sign_up');
    else if (/customer_login|login/i.test(id) || /\/account\/login/.test(action)) authIntent('login');
  }
  function checkAuthChange() {
    if (!session) return;
    var now = cfg.dims.user_state;
    var prev = null;
    try { prev = session.getItem('squid_user_state'); session.setItem('squid_user_state', now); } catch (e) { return; }
    if (prev !== 'guest' || now !== 'member') return;
    var intent = readJson(session, 'squid_auth_intent');
    try { session.removeItem('squid_auth_intent'); } catch (e) {}
    var fresh = intent && Date.now() - intent.at < 30 * 60 * 1000;
    var kind = fresh ? intent.kind : 'login';
    pushEvent(kind === 'sign_up' ? 'sign_up' : 'login', { method: kind === 'shop-login-button' ? 'shop' : 'email' });
  }

  /* ───────── filter_apply — 컬렉션 필터·정렬 (beconnow 와 같은 이름) ─────────
     filter_type 은 입력 이름에서 (filter.v.option.color → v.option.color · sort_by → sort) · 값은 옵션 값 그대로(영어) */
  function onChange(ev) {
    var t = ev.target;
    if (!t || !t.name) return;
    var isSort = t.name === 'sort_by';
    var form = t.closest('facet-filters-form, form[id^="FacetFiltersForm"], form.facets__form');
    if (!form && !isSort) return;
    var type = isSort ? 'sort' : t.name.replace(/^filter\./, '');
    var value = t.type === 'checkbox' ? (t.checked ? t.value : 'off:' + t.value) : t.value;
    pushEvent('filter_apply', { filter_type: type.slice(0, 40), filter_value: String(value || '').slice(0, 100), section_name: readSectionName(t) });
  }

  /* Klaviyo 가입 창 — Klaviyo 가 창을 열고 닫고 보낼 때 window 에 klaviyoForms 를 쏜다 (Klaviyo 공식 · iframe 이 아니라 우리 창에서 받는다)
     ★submit 은 첫 단계(이메일)를 보냈을 때 한 번 — newsletter_signup (리드 아님 · 위 폼 제출 머리말).
       detail.metaData 에 이메일이 들어 있다 — 읽지 않는다. formId 만 쓴다 */
  function onKlaviyo(ev) {
    var d = (ev && ev.detail) || {};
    var name = ('klaviyo_' + (d.formId || 'form')).replace(/[^a-z0-9]+/gi, '_').toLowerCase().slice(0, 40);
    if (d.type === 'open' || d.type === 'embedOpen') pushEvent('modal_view', { modal_name: name, modal_type: d.type === 'open' ? 'modal' : 'embed' });
    else if (d.type === 'close') pushEvent('modal_close', { modal_name: name, modal_type: 'modal', close_method: 'dismiss' });
    else if (d.type === 'submit' && onceThisLanding(name)) pushEvent('newsletter_signup', assign({ form_id: name, method: 'klaviyo' }, firstParams()));
  }

  /* ───────── 판정 함수 입구 (읽기만) ─────────
     전수 도구가 «운영과 같은 판정»으로 화면을 잰다 — 비슷한 규칙을 도구 쪽에 다시 짜지 않는다 (원장 #빠진것은기계로전수 규칙 2).
     여기서 이벤트를 보내지 않는다. */
  cfg.inspect = {
    INTERACTIVE_SELECTOR: INTERACTIVE_SELECTOR,
    TYPING_SELECTOR: TYPING_SELECTOR,
    SECTION_SELECTOR: SECTION_SELECTOR,
    resolveClickTarget: resolveClickTarget,
    resolveElementId: resolveElementId,
    readElementText: readElementText,
    readSectionName: readSectionName,
    readPosition: readPosition,
    readLinkUrl: readLinkUrl,
    fallbackElementId: fallbackElementId,
    sectionKey: sectionKey
  };

  /* ───────── 설치 ───────── */
  doc.addEventListener('click', onClick, true);
  doc.addEventListener('click', onRageClick, true);
  doc.addEventListener('scroll', onScroll, { capture: true, passive: true });
  w.addEventListener('message', onCalendlyMessage, false);
  doc.addEventListener('click', noteCloseIntent, true);
  doc.addEventListener('keyup', noteCloseIntent, true);
  doc.addEventListener('submit', onSubmit, true);
  doc.addEventListener('change', onChange, true);
  w.addEventListener('error', onErrorEvent, true);
  w.addEventListener('klaviyoForms', onKlaviyo, false);

  function onReady() {
    installSections();
    patchInlineWidgets();
    checkPostedForms();
    checkAuthChange();
    new MutationObserver(onOverlayMutation).observe(doc.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });
    new MutationObserver(scheduleFrictionScan).observe(doc.body, { childList: true, subtree: true, characterData: true });
    scheduleFrictionScan();
    if (!wrapCalendlyPopup()) {
      var tries = 0;
      var t = w.setInterval(function () { if (wrapCalendlyPopup() || ++tries > 40) w.clearInterval(t); }, 250);
    }
    // widget.js 가 뒤늦게 한 번 더 실려 덮어도 — 열기 직전에 다시 감싼다 (위 wrapCalendlyPopup 머리말)
    w.addEventListener('load', wrapCalendlyPopup);
    doc.addEventListener('pointerdown', wrapCalendlyPopup, true);
    doc.addEventListener('click', wrapCalendlyPopup, true);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', onReady);
  else onReady();
})();
